import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';

import { Text } from '@atlaskit/primitives/compiled';

import type { UpdateWorkItemFieldsAction } from '../../../../../common/types';

import type { datePickerField_updateWorkItemFieldsActionRenderer$key } from './__generated__/datePickerField_updateWorkItemFieldsActionRenderer.graphql';
import { formatSuggestedDate } from './utlis';

const messages = defineMessages({
	set: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.date-picker-field.set',
		defaultMessage: 'Set {name} to {value}',
		description: 'Label for the change action in the date picker field',
	},
	unset: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.date-picker-field.unset',
		defaultMessage: 'Remove date from {name}',
		description: 'Label for the change action in the date picker field',
	},
});

export type Props = {
	queryRef: datePickerField_updateWorkItemFieldsActionRenderer$key;
	action: UpdateWorkItemFieldsAction;
};

export const DatePickerField = ({ queryRef, action }: Props): React.JSX.Element | null => {
	const { formatMessage, formatDate } = useIntl();

	const data = useFragment(
		graphql`
			fragment datePickerField_updateWorkItemFieldsActionRenderer on JiraDatePickerField {
				fieldId
				name
			}
		`,
		queryRef,
	);

	if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) {
		return null;
	}

	const fieldName = data?.name ? data.name.toLowerCase() : action.data.fieldKey;
	const formattedDate = formatSuggestedDate(action.data.fieldValue, formatDate);

	return (
		<Text
			color="color.text.subtle"
			maxLines={1}
			testId="update-work-item-fields-action-renderer.ui.action-card.card-fields-list.date-picker-field"
		>
			{formattedDate
				? formatMessage(messages.set, { name: fieldName, value: formattedDate })
				: formatMessage(messages.unset, { name: fieldName })}
		</Text>
	);
};
